export function createMarkerContent(src: string, size: number, count?: number, addPulsingCircle?: boolean): HTMLElement {

  // =========================
  // 🔹 MARKER CONTAINER SETUP
  // =========================

  const container = document.createElement('div');
  container.classList.add('marker-container');

  // =========================
  // 🔹 OPTIONAL PULSING EFFECT
  // =========================

  if (addPulsingCircle) {
    const pulsingCircle = document.createElement('svg');
    pulsingCircle.classList.add('pulsing-circle');

    const circle = document.createElement('circle');
    pulsingCircle.appendChild(circle);
    container.appendChild(pulsingCircle);
  }

  // =========================
  // 🔹 MARKER ICON RENDERING
  // =========================

  const icon = document.createElement('img');
  icon.src = src;
  icon.width = size;
  container.appendChild(icon);

  // =========================
  // 🔹 OPTIONAL COUNT BADGE
  // =========================

  if (count && count > 0) {
    const countText = document.createElement('span');
    countText.innerText = String(count);
    countText.classList.add('count-text');
    container.appendChild(countText);
  }

  return container;
}